export default "__VITE_ASSET__JCKE1lqF__"